import React from 'react';

import { ReactComponent as CapintelLogo } from '../../../images/capintel-logo.svg?react';
import { FormattedMessage } from '../../../utils/i18n';
import { RouteComponentProps } from 'react-router';
import qs from 'qs';

type Props = RouteComponentProps & {};

const Error = (props: Props) => {
  const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });

  return (
    <div className="auth d-flex flex-column">
      <div className="auth-header d-flex align-items-center">
        <div className="container">
          <a href={import.meta.env.REACT_APP_WEBSITE_HOST} aria-label="CapIntel">
            <CapintelLogo className="capintel-logo logo-large" />
          </a>
        </div>
      </div>
      <div className="auth-content-container">
        <div className="auth-content">
          <div className="login">
            <h1>
              <FormattedMessage id="Error.Title" />
            </h1>
            <p className="sub-title">{query.error}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
